import { render } from "./TrustSection.vue?vue&type=template&id=07b34ad6&scoped=true"
import script from "./TrustSection.vue?vue&type=script&lang=js"
export * from "./TrustSection.vue?vue&type=script&lang=js"

import "./TrustSection.vue?vue&type=style&index=0&id=07b34ad6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b34ad6"]])

export default __exports__